<fd-card class="help-center-card">
  <fd-card-content>
    <fd-avatar size="xs" [border]="true" [colorAccent]="10" [glyph]="glyph" />
    <fd-icon />
    <!-- keep, otherwise avatar is not shown -->
    <h5 fd-title>{{ title }}</h5>
    <p>{{ subtitle }}</p>
  </fd-card-content>
  <fd-card-footer>
    <button
      *fdCardFooterActionItem
      fd-button
      [attr.data-testid]="buttonDataTestId"
      [label]="buttonText"
      (click)="emitClickedEvent()"
    ></button>
  </fd-card-footer>
</fd-card>
